import { MyNumberWithID } from "@graffer-inc/cloud-gov-core";
import { MyNumberRefKeyExchanger } from "@graffer-inc/form-schema";
import apiClient from "../../apis/api-client";

export class ReadonlyFetchMyNumberExchanger implements MyNumberRefKeyExchanger {
  constructor(
    private myNumbers: MyNumberWithID[],
    private applicationId: string,
    private applicationHistoryId?: string,
  ) {}

  refkeyToValue(refkey: string) {
    const myNumber = this.myNumbers.find((v) => v.refKey === refkey);
    return {
      applicationId: this.applicationId,
      value: myNumber?.myNumberId || "",
      requestDecrypt: async () => {
        const { data } = await apiClient.fetchApplicationMyNumber(
          this.applicationId,
          refkey,
          this.applicationHistoryId,
        );
        return data.myNumber;
      },
      skipValidate: !!myNumber,
    };
  }

  valueToRefkey(_: string): string {
    throw new Error("should not be called");
  }

  clearRefKey(): void {
    throw new Error("should not be called");
  }
}
